module.exports = __webpack_public_path__ + "static/img/btn.b6f55a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb-activity/btn.png
// module id = tqOI
// module chunks = 39